import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'ejtimaa_business';
  constructor(public router : Router) {
    console.log('routerUrl',router.url);
  }

}
